import { render, staticRenderFns } from "./CarChoose.vue?vue&type=template&id=a68769bc&"
import script from "./CarChoose.vue?vue&type=script&lang=js&"
export * from "./CarChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports